import React from "react";
import { useWithdrawal } from "src/hooks";
import { EWithdrawalStep } from "src/types";
import {
  WithdrawalInitialStep,
  WithdrawalBankSelectionStep,
  WithdrawalConfirmationStep,
  WithdrawalStatusStep,
  MfaSetupAlert,
} from "src/components";
import { PaymentsRoutesResponse } from "src/api";
import "./withdrawal-form.scss";

const WithdrawalForm: React.FC<{ paymentsRoutes: PaymentsRoutesResponse }> = ({ paymentsRoutes }): JSX.Element => {
  const {
    amount,
    handleAmountChange,
    paymentFee,
    paymentFeeLoading,
    errors,
    balance,
    handleStepChange,
    withdrawalStep,
    banksList,
    selectedBank,
    accountNumber,
    handleBankSelection,
    mfaCode,
    setMfaCode,
    userUseMfa,
    isMfaRequired,
    isRtcEnabled,
    handleRtcChange,
  } = useWithdrawal({ paymentsRoutes });

  const renderFirstStep = () => {
    return (
      <WithdrawalInitialStep
        amount={amount}
        handleAmountChange={handleAmountChange}
        balance={balance}
        paymentFee={paymentFee}
        paymentFeeLoading={paymentFeeLoading}
        errors={errors}
        handleStepChange={handleStepChange}
        withdrawalStep={withdrawalStep}
        isRtcEnabled={isRtcEnabled}
        handleRtcChange={handleRtcChange}
      />
    );
  };

  const renderSecondStep = () => {
    return (
      <WithdrawalBankSelectionStep
        banksList={banksList}
        handleStepChange={handleStepChange}
        handleBankSelection={handleBankSelection}
        selectedBankFromState={selectedBank}
        accountNumberFromState={accountNumber}
        withdrawalStep={withdrawalStep}
      />
    );
  };

  const renderThirdStep = () => {
    return (
      <WithdrawalConfirmationStep
        amount={amount}
        paymentFee={paymentFee}
        balance={balance}
        selectedBank={selectedBank}
        accountNumber={accountNumber}
        handleStepChange={handleStepChange}
        withdrawalStep={withdrawalStep}
        isMfaRequired={isMfaRequired}
        mfaCode={mfaCode}
        setMfaCode={setMfaCode}
      />
    );
  };

  const renderFourthStep = () => {
    return <WithdrawalStatusStep />;
  };

  const withdrawalSteps = {
    [EWithdrawalStep.AmountInput]: renderFirstStep,
    [EWithdrawalStep.BankSelection]: renderSecondStep,
    [EWithdrawalStep.ConfirmWithdrawal]: renderThirdStep,
    [EWithdrawalStep.InitiateWithdrawal]: renderFourthStep,
  };

  if (isMfaRequired && !userUseMfa) {
    return <MfaSetupAlert />;
  }

  return <>{withdrawalSteps[withdrawalStep.currentStep]()}</>;
};

export default WithdrawalForm;
